/*@ngInject*/
const BrowserUtil = function (xmlUtil) {

    this.getBrowserInfo = function () {
        let ua = navigator.userAgent, tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE, Ver: ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem !== null) {
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
            M.splice(1, 1, tem[1]);
        }
        return M[0] + ', Ver: ' + M[1];
    };

    this.isChrome = function () {
        return _.includes(_.toLower(this.getBrowserInfo()), 'chrome');
    };

    this.isEdge = function () {
        return _.includes(_.toLower(this.getBrowserInfo()), 'edge');
    };

    this.isFirefox = function(){
        return _.includes(_.toLower(this.getBrowserInfo()), 'firefox');
    };

    this.isIE11 = function(){
        return !(window.ActiveXObject) && 'ActiveXObject' in window;
    };

    this.getOSName = function () {
        let OSName = 'Unknown',
            userAgent = navigator.userAgent;
        if (userAgent.indexOf('Windows NT 10.0') !== -1) {
            OSName = 'Windows 10';
        }
        if (userAgent.indexOf('Windows NT 6.2') !== -1) {
            OSName = 'Windows 8';
        }
        if (userAgent.indexOf('Windows NT 6.1') !== -1) {
            OSName = 'Windows 7';
        }
        if (userAgent.indexOf('Windows NT 6.0') !== -1) {
            OSName = 'Windows Vista';
        }
        if (userAgent.indexOf('Windows NT 5.1') !== -1) {
            OSName = 'Windows XP';
        }
        if (userAgent.indexOf('Windows NT 5.0') !== -1) {
            OSName = 'Windows 2000';
        }
        if (userAgent.indexOf('Mac') !== -1) {
            OSName = 'Mac/iOS';
        }
        if (userAgent.indexOf('X11') !== -1) {
            OSName = 'UNIX';
        }
        if (userAgent.indexOf('Linux') !== -1) {
            OSName = 'Linux';
        }
        return OSName;
    };
};

angular.module('umCore')
    .service('browserUtil', BrowserUtil);
